import { createGlobalStyle } from 'styled-components';

/**
 * Global baseline + CSS custom properties, ported from shared.css `:root`.
 * Declaring the variables here lets ported component CSS reference `var(--…)`
 * directly while styled-components also consumes the typed `theme` object.
 */
export const GlobalStyle = createGlobalStyle`
  :root {
    --k-black: #0A0A0A;
    --k-ink: #1A1A1A;
    --k-paper: #FAFAF7;
    --k-line: #E8E6DF;
    --k-muted: #6B6B66;
    --k-accent: #2D2D2A;

    --bg: #FAFAF7;
    --card: #FFFFFF;
    --text: #141413;
    --text-muted: #6B6B66;
    --border: #E8E6DF;
    --shadow: 0 1px 2px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.04);
    --shadow-lg: 0 4px 12px rgba(0,0,0,0.06), 0 16px 40px rgba(0,0,0,0.08);

    --radius: 12px;
    --radius-sm: 8px;
    --radius-lg: 20px;
  }

  * { box-sizing: border-box; }

  html, body {
    margin: 0;
    padding: 0;
    font-family: ${({ theme }) => theme.font.sans};
    background: ${({ theme }) => theme.color.bg};
    color: ${({ theme }) => theme.color.text};
    -webkit-font-smoothing: antialiased;
    font-feature-settings: 'cv02','cv03','cv04','cv11';
  }

  a { color: inherit; text-decoration: none; }

  html, body, #root {
    min-height: 100vh;
    width: 100%;
  }

  h1, h2, h3 { letter-spacing: -0.02em; margin: 0; }

  button { font-family: inherit; }
`;
